<template>
    <div class="text-xs text-dgreen inline-block">
        <fa :icon="['fas', 'star']" class="inline-block" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block text-gray-100" v-if="score <= 1" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block" :class="height" v-else />
        <fa :icon="['fas', 'star']" class="inline-block text-gray-100" v-if="score <= 2" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block" :class="height" v-else />
    <fa :icon="['fas', 'star']" class="inline-block text-gray-100" v-if="score <= 3" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block" :class="height" v-else />
        <fa :icon="['fas', 'star']" class="inline-block text-gray-100" v-if="score < 4" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block" v-if="score > 4.8" :class="height" />
        <fa :icon="['fas', 'star']" class="inline-block text-gray-100" v-else-if="score == 4" :class="height" />
        <fa :icon="['fad', 'star-half']"  style="--fa-secondary-color: rgb(213, 213, 213);" class="inline-block" v-else-if="score > 4" :class="height" />
    </div>
</template>

<script setup>
const props = defineProps({
    score: Number,
    height: {
        type: String,
        default:'h-4'
    }
});
</script>
